
export const compactParams = (obj = {}) =>
  Object.keys(obj).reduce((acc, k) => {
    const v = obj[k]
    if (v !== '' && v !== null && v !== undefined) acc[k] = v
    return acc
  }, {})

export const parseFileName = (headers) => {
  try {
    const cd = headers && (headers['content-disposition'] || headers['Content-Disposition'])
    if (!cd) return null
    const matchUtf = /filename\*=UTF-8''([^;]+)/i.exec(cd)
    if (matchUtf && matchUtf[1]) return decodeURIComponent(matchUtf[1])
    const match = /filename="?([^"]+)"?/i.exec(cd)
    if (match && match[1]) return match[1]
    return null
  } catch {
    return null
  }
}

export const downloadBlob = (blob, fileName) => {
  const url = window.URL.createObjectURL(blob)
  const a = document.createElement('a')
  a.href = url
  a.download = fileName || `applications_${new Date().toISOString().slice(0,10)}.xlsx`
  document.body.appendChild(a)
  a.click()
  a.remove()
  window.URL.revokeObjectURL(url)
}
